import React, { Component } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import './thumbnail.css'
import TextClamp from 'react-string-clamp'

export class Thumbnail extends Component {

    static propTypes = {
        onClick: PropTypes.func.isRequired,
        selected: PropTypes.bool.isRequired,
        thumbnail: PropTypes.string.isRequired,
        position: PropTypes.number.isRequired,
        title: PropTypes.string,
    }

    render()
    {
        const {thumbnail, onClick, title, selected} = this.props
        const position = this.props.position + 1

        return (
            <div>
                <label className='thumbnail-label'>{position}</label>
                <img
                    src={thumbnail}
                    className={classNames('thumbnail', {'selected': selected})}
                    onClick={onClick}
                    alt={position}
                    title={title}
                />

                {title && <div title={title}><TextClamp lines='2' className='thumbnail-title' text={title} /></div>}
            </div>
        )
    }
}
